import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const steps = [
  {
    num: "01",
    title: "Pilih Event",
    desc: "Browse halaman event, lihat jadwal, lokasi, dan detail acara yang tersedia.",
  },
  {
    num: "02",
    title: "Isi Data Diri",
    desc: "Masukkan nama lengkap dan alamat email yang aktif untuk keperluan konfirmasi.",
  },
  {
    num: "03",
    title: "Pilih Tipe Tiket",
    desc: "Tentukan jenis dan jumlah tiket yang ingin kamu pesan sesuai kebutuhan.",
  },
  {
    num: "04",
    title: "Lakukan Pembayaran",
    desc: "Transfer sesuai nominal yang tertera, lalu upload bukti bayar di halaman booking.",
  },
  {
    num: "05",
    title: "Terima Tiket via Email",
    desc: "Setelah verifikasi, tiket QR-code langsung dikirim ke emailmu. Tunjukkan saat hari-H.",
  },
];

export default function HowToBook() {
  const headerRef = useRef(null);
  const stepRefs = useRef([]);
  const ctaRef = useRef(null);

  useEffect(() => {
    const targets = [
      headerRef.current,
      ...stepRefs.current.filter(Boolean),
      ctaRef.current,
    ].filter(Boolean);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    targets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="how-to-book" id="book">
      <div className="container">
        {/* Header */}
        <div className="how-to-book__header" ref={headerRef}>
          <span className="overline">Cara Booking</span>
          <h2>
            Dari klik pertama sampai<br />
            tiket ada di <em>tanganmu</em>
          </h2>
          <p>
            Lima langkah simpel — tidak butuh akun, tidak butuh antre.
            Semua serba online.
          </p>
        </div>

        {/* Step rows */}
        <div className="how-to-book__steps">
          {steps.map((step, i) => (
            <div
              key={step.num}
              className="step"
              ref={(el) => (stepRefs.current[i] = el)}
            >
              <span className="step__num">{step.num}</span>
              <span className="step__title">{step.title}</span>
              <p className="step__desc">{step.desc}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="how-to-book__cta" ref={ctaRef}>
          <Link to="/events">
            Lihat Event Sekarang
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </Link>
          {/* <span className="cta-hint">Gratis · Tanpa perlu daftar akun</span> */}
        </div>
      </div>
    </section>
  );
}
